var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import HeaderLogo from './HeaderLogo';
import SideContainer from './SideContainer';
import { useCallback, useEffect, useState } from 'react';
/**
 * This makes it easy to create headers with sidebar
 * and easily customize channels that express yourself,
 * such as personal blog, linked-in, etc.
 *
 * @props headerHeight: Header height style (default: '80px')
 * @props headerWidth: Header Width style (default: '100%')
 * @props headerBackgroundColor: Header background color style (default: 'white')
 *
 * @props logoOption: You can customize the attrs such as logo and title by using logoOption props.
 * @props channels: Enter channels to express yourself, such as personal blog, linked-in, etc.
 * @props sideBarOption: You can customize the attrs such as title and item in sidebar by using sideBarOption props.
 *
 * @refer
 * If you want to check the value of logoOption, channels, sideBarOption, please check the following link. {@link https://github.com/modern-agile-team/dev-portfolio#more-about-headers-props}
 */
var Header = function (_a) {
    var _b = _a.logoOption, logoOption = _b === void 0 ? {} : _b, channels = _a.channels, sideBarOption = _a.sideBarOption, headerHeight = _a.headerHeight, headerWidth = _a.headerWidth, headerBackgroundColor = _a.headerBackgroundColor;
    var redirectUrl = logoOption.redirectUrl, logoImg = logoOption.logoImg, logoHidden = logoOption.logoHidden, title = logoOption.title, logoMargin = logoOption.logoMargin, logoWidth = logoOption.logoWidth, logoHeight = logoOption.logoHeight, titleColor = logoOption.titleColor, titleSize = logoOption.titleSize, titleWeight = logoOption.titleWeight;
    var _c = useState({ value: 0, direction: 'down', scrollUpTimes: 0 }), pageY = _c[0], setPageY = _c[1];
    var detectScroll = useCallback(function () {
        setPageY(function (_a) {
            var value = _a.value, scrollUpTimes = _a.scrollUpTimes;
            if (value > window.scrollY)
                return { value: window.scrollY, direction: 'up', scrollUpTimes: scrollUpTimes + 1 };
            else
                return { value: window.scrollY, direction: 'down', scrollUpTimes: scrollUpTimes - 1 };
        });
    }, [pageY]);
    useEffect(function () {
        window.addEventListener('scroll', detectScroll);
        return function () { return window.removeEventListener('scroll', detectScroll); };
    }, []);
    return (_jsxs(Container, __assign({ headerHeight: headerHeight, headerWidth: headerWidth, headerBackgroundColor: headerBackgroundColor, pageY: pageY }, { children: [_jsx(HeaderLogo, { redirectUrl: redirectUrl, logoImg: logoImg, logoHidden: logoHidden, logoMargin: logoMargin, logoWidth: logoWidth, logoHeight: logoHeight, title: title, titleColor: titleColor, titleSize: titleSize, titleWeight: titleWeight }), _jsx(SideContainer, { channels: channels, sideBarOption: sideBarOption })] })));
};
export default Header;
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: sticky;\n  top: 0;\n  z-index: 10000;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: ", ";\n  width: ", ";\n  margin: '0px';\n  padding: '0px';\n  background-color: ", ";\n  top: 0;\n  ", ";\n"], ["\n  position: sticky;\n  top: 0;\n  z-index: 10000;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: ", ";\n  width: ", ";\n  margin: '0px';\n  padding: '0px';\n  background-color: ", ";\n  top: 0;\n  ", ";\n"])), function (_a) {
    var headerHeight = _a.headerHeight;
    return headerHeight !== null && headerHeight !== void 0 ? headerHeight : '80px';
}, function (_a) {
    var headerWidth = _a.headerWidth;
    return headerWidth !== null && headerWidth !== void 0 ? headerWidth : '100%';
}, function (_a) {
    var headerBackgroundColor = _a.headerBackgroundColor;
    return headerBackgroundColor !== null && headerBackgroundColor !== void 0 ? headerBackgroundColor : 'whitesmoke';
}, function (props) {
    var MAX_SCROLL_COUNT = 10;
    var MAX_HIDE = 250;
    var top = -MAX_HIDE;
    if (top < 0) {
        top += (-top / MAX_SCROLL_COUNT) * props.pageY.scrollUpTimes;
        if (top < -MAX_HIDE) {
            props.pageY.scrollUpTimes = 0;
            top = -MAX_HIDE;
        }
        else if (top >= 0) {
            props.pageY.scrollUpTimes = MAX_SCROLL_COUNT;
            top = 0;
        }
    }
    if (props.pageY.value <= 0) {
        top = 0;
        props.pageY.scrollUpTimes = 0;
    }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      transition: 0.3s;\n      top: ", "px;\n    "], ["\n      transition: 0.3s;\n      top: ", "px;\n    "])), top > 0 ? 0 : top);
});
var templateObject_1, templateObject_2;
